import Navbar from '@/components/feature/Navbar';
import ServicesSection from '@/pages/home/components/ServicesSection';
import CTASection from '@/pages/home/components/CTASection';
import Footer from '@/components/feature/Footer';

export default function ServicesPage() {
  return (
    <main>
      <Navbar />
      <div className="h-20"></div>
      <ServicesSection />
      <CTASection />
      <Footer />
    </main>
  );
}